import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'phoenix-alert-dialog-info',
  template: `
    <mat-dialog-content
      class="mat-typography flex align-middle justify-center items-center h-full"
    >
      <ng-container
        *ngTemplateOutlet="data.template; context: data.context"
      ></ng-container>
    </mat-dialog-content>
    @if (data.showActions) {
      <mat-dialog-actions align="center" class="flex items-center">
        @if (data.templateActions) {
          <ng-container *ngTemplateOutlet="data.templateActions"></ng-container>
        }
        <button mat-button color="primary" matButton="filled" mat-dialog-close>
          Close
        </button>
      </mat-dialog-actions>
    }
  `,
  styles: [],
  standalone: false,
})
export class DialogInfoComponent {
  data = inject(MAT_DIALOG_DATA);
}
